<template>

  <b-card :class="'card-' + backgroundColor">
    <div class="bold-text level-three-title">
      {{ $t(title) }}
      <b-tooltip aria-rowcount="3" html target="info-circle-expense" variant="dark">
        {{ this.$t('ProfessionalCharges') + ': ' + chargesPro + '€' }} <br>
        {{ this.$t('society.balance.sheet.versement.investor') + ': ' + interests + '€' }}
      </b-tooltip>
    </div>
    <div class="huge-text-treso">
      {{ value }}
    </div>
  </b-card>

</template>

<script>

export default {

  name: 'TreasuryCardComponent',

  props: {
    title: String,
    backgroundColor: {
      String,
      default: "main-color-text"
    },
    value: String,
    chargesPro: {
      type: String,
      required: false,
      default: null
    },
    interests: {
      type: String,
      required: false,
      default: null
    },

  },

  methods: {}

}

</script>

<style scoped>

.huge-text-treso {
  font-family: "Montserrat", "Arial", sans-serif;
  text-transform: uppercase;
  font-size: 19px;
}


</style>



// WEBPACK FOOTER //
// src/components/TreasuryCardComponent.vue